var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("clearanceApproval.response.title")) + " ")]), _c('v-card-subtitle', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("clearanceApproval.response.subtitle")) + " ")]), _vm.value.due ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("thg.PriceTable.to", {
    date: _vm.simpleDoubleDigitDate(_vm.value.due)
  })) + " ")]) : _vm._e()], 1), _c('v-card-text', [_c('line-items-form', {
    attrs: {
      "readonly": true,
      "showProducts": false,
      "showQuantity": false,
      "showTax": false
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), !_vm.value.isCompleted ? _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "info",
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("clearanceApproval.response.makeOffer")) + " ")])], 1) : _vm._e()], 1), _vm.value.history && _vm.value.history.length > 0 ? _c('clearance-approval-response-card-history', {
    attrs: {
      "value": _vm.value
    }
  }) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "title": _vm.$t('clearance.clearances'),
      "subtitle": _vm.$t('clearanceApproval.response.makeOfferSubtitle'),
      "loading": _vm.loading,
      "rightLoading": _vm.loading || _vm.loadingRequestMoreData || _vm.loadingRespondReject,
      "rightDisabled": !_vm.isValid,
      "hideRight": _vm.hideRight,
      "leftText": _vm.leftText,
      "rightText": _vm.rightText
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-radio-group', {
    model: {
      value: _vm.response,
      callback: function callback($$v) {
        _vm.response = $$v;
      },
      expression: "response"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('clearanceApproval.response.makeOffer'),
      "value": _vm.ResponseType.ACCEPT
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('clearanceApproval.response.requestMore'),
      "value": _vm.ResponseType.REQUEST
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('clearanceApproval.response.reject'),
      "value": _vm.ResponseType.REJECT
    }
  })], 1), _vm.response === _vm.ResponseType.REQUEST ? _c('v-textarea', {
    attrs: {
      "label": _vm.$t('clearanceApproval.response.requestMoreReason'),
      "hint": _vm.$t('clearanceApproval.response.requestMoreReasonHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.requestMoreDataReason,
      callback: function callback($$v) {
        _vm.requestMoreDataReason = $$v;
      },
      expression: "requestMoreDataReason"
    }
  }) : _vm._e(), _vm.response === _vm.ResponseType.REJECT ? _c('v-textarea', {
    attrs: {
      "label": _vm.$t('clearanceApproval.response.rejectReason'),
      "hint": _vm.$t('clearanceApproval.response.rejectReasonHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.rejectReason,
      callback: function callback($$v) {
        _vm.rejectReason = $$v;
      },
      expression: "rejectReason"
    }
  }) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }